import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import PageRoutes from "./routes";

function App() {
  console.log("App component rendered");
  return (
    <Router>
      <PageRoutes />
    </Router>
  );
}

export default App;
